export const PARSE_RFG_START = 'PARSE_RFG_START';
export const PARSE_RFG_START_SUCCESS = 'PARSE_RFG_START_SUCCESS';
export const PARSE_RFG_START_ERROR = 'PARSE_RFG_START_ERROR';
export const PARSE_RFG_START_CONFLICT = 'PARSE_RFG_START_CONFLICT';
export const PARSE_RFG_CLEAR_CONFLICT = 'PARSE_RFG_CLEAR_CONFLICT';
export const PARSE_RFG_FETCH = 'PARSE_RFG_FETCH';
export const PARSE_RFG_FETCH_SUCCESS = 'PARSE_RFG_FETCH_SUCCESS';
export const PARSE_RFG_FETCH_DOCUMENTO = 'PARSE_RFG_FETCH_DOCUMENTO';
export const PARSE_RFG_FETCH_DOCUMENTO_SUCCESS = 'PARSE_RFG_FETCH_DOCUMENTO_SUCCESS';
export const PARSE_RFG_CLEAN = 'PARSE_RFG_CLEAN';
